import React from 'react';
import { Svg, Path, Defs, ClipPath, G, Rect } from 'react-native-svg';

export const SadFaceIcon = ({ color = '#333333', size = 30 }) => (
    <Svg
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <G clipPath="url(#sad-face-id)">
            <Path
                d="M15.35 5.09998C9.82717 5.09998 5.35002 9.57713 5.35002 15.1C5.35002 20.6228 9.82717 25.1 15.35 25.1C20.8729 25.1 25.35 20.6228 25.35 15.1C25.35 9.57713 20.8729 5.09998 15.35 5.09998ZM2.85002 15.1C2.85002 8.19642 8.44646 2.59998 15.35 2.59998C22.2536 2.59998 27.85 8.19642 27.85 15.1C27.85 22.0035 22.2536 27.6 15.35 27.6C8.44646 27.6 2.85002 22.0035 2.85002 15.1Z"
                fill={color}
            />
            <Path
                d="M12.85 11.975C12.85 13.0105 12.0106 13.85 10.975 13.85C9.93949 13.85 9.10002 13.0105 9.10002 11.975C9.10002 10.9394 9.93949 10.1 10.975 10.1C12.0106 10.1 12.85 10.9394 12.85 11.975Z"
                fill={color}
            />
            <Path
                d="M21.6 11.975C21.6 13.0105 20.7606 13.85 19.725 13.85C18.6895 13.85 17.85 13.0105 17.85 11.975C17.85 10.9394 18.6895 10.1 19.725 10.1C20.7606 10.1 21.6 10.9394 21.6 11.975Z"
                fill={color}
            />
            <Path
                d="M19.9935 17.0545C20.9468 18.0646 21.414 19.2021 21.5627 19.7968L19.1374 20.4031C19.0777 20.1645 18.795 19.427 18.1753 18.7704C17.5893 18.1495 16.7072 17.6 15.35 17.6C13.9929 17.6 13.1108 18.1495 12.5247 18.7704C11.9051 19.427 11.6224 20.1645 11.5627 20.4031L9.13736 19.7968C9.28604 19.2021 9.75329 18.0646 10.7066 17.0545C11.6935 16.0088 13.2072 15.1 15.35 15.1C17.4929 15.1 19.0066 16.0088 19.9935 17.0545Z"
                fill={color}
            />
        </G>
        <Defs>
            <ClipPath id="sad-face-id">
                <Rect
                    width="28.8"
                    height="28.8"
                    fill="white"
                    transform="translate(0.850021 0.599976)"
                />
            </ClipPath>
        </Defs>
    </Svg>
);
